// Unity's stable identifier; names may be edited. Only choose from assignments.
export const UNITY_COMPANY_UUID = '695a455b-1fc6-4c0d-a0a9-306809560338';

export function defaultCompany(companies: any[], requestedUuid?: string) {
  return companies?.find(company => company.uuid === requestedUuid)
    || companies?.find(company => company.uuid === UNITY_COMPANY_UUID)
    || companies?.[0];
}
